import React, { useState } from "react";
import { Grid, TextField, Button, Container } from "@mui/material";
import { useSelector } from "react-redux";
import Header from "components/Header";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import tresoImage from "../assets/tresoImage.png";
import api from "services/api";

const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

const TresorerieGlobale = () => {
  const mode = useSelector((state) => state.global.mode);

  const [formData, setFormData] = useState({
    selectedDate: getCurrentDate(),
    soldeCaissefm: 0,
    totalSoldeComptes: 0,
    totalTresoDispo: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]:
        name === "selectedDate"
          ? value
          : value === ""
            ? ""
            : parseFloat(value),
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await api.post(
        "/api/tresorerieglobale",
        formData
      );

      console.log("Form submitted:", response.data);

      toast.success("Record added successfully.");

      setFormData({
        selectedDate: getCurrentDate(),
        soldeCaissefm: 0,
        totalSoldeComptes: 0,
        totalTresoDispo: 0,
      });
    } catch (error) {
      console.error("Error submitting the form!", error);

      toast.error(
        "Error submitting the form. Please try again."
      );
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, ml: 3 }}>
      <Header
        title="Ajouter une donnée de trésorerie globale"
        subtitle="Les valeurs 0 sont remplies par défaut"
        sx={{ mb: 5 }}
      />
      <Grid container spacing={3} sx={{ mt: 4 }}>
        <Grid item xs={8}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label="Date"
                  type="date"
                  name="selectedDate"
                  value={formData.selectedDate}
                  onChange={handleChange}
                  required
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Total Trésorerie Disponible"
                  type="number"
                  name="totalTresoDispo"
                  value={formData.totalTresoDispo}
                  onChange={handleChange}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Solde Caisse FM"
                  type="number"
                  name="soldeCaissefm"
                  value={formData.soldeCaissefm}
                  onChange={handleChange}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Total Solde Comptes"
                  type="number"
                  name="totalSoldeComptes"
                  value={formData.totalSoldeComptes}
                  onChange={handleChange}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color={mode === "dark" ? "secondary" : "primary"}
                  size="large"
                  sx={{
                    width: "100%",
                  }}
                >
                  Ajouter
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
        <Grid item xs={4} container alignItems="center" justifyContent="center">
          <img
            src={tresoImage}
            alt="Forage"
            style={{
              width: "100%",
              maxWidth: "200px",
              display: "block",
              margin: "0 auto",
              borderRadius: 10,
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default TresorerieGlobale;
